import React, { useState, useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import api from '../../services/api';
import Snackbar from '../../util/SnackBar';

const STATUS_OPTIONS = ['Available', 'Cancelled'];

const parseStyleCodes = raw => {
  if (!raw) return [];
  const tokens = raw.split(/[\s,;]+/).map(t => t.trim()).filter(Boolean);
  return Array.from(new Set(tokens));
};

export default function BulkProductStatus() {
  const [raw, setRaw] = useState('');
  const [status, setStatus] = useState('Available');
  const [saving, setSaving] = useState(false);

  const styleCodes = useMemo(() => parseStyleCodes(raw), [raw]);

  const handleApply = async () => {
    if (styleCodes.length === 0) {
      Snackbar.warning('Paste at least one style code');
      return;
    }
    const body = styleCodes.map(style_code => ({ style_code, status }));
    setSaving(true);
    try {
      await api.put('/products', body);
      Snackbar.success(
        `${styleCodes.length} product${
          styleCodes.length === 1 ? '' : 's'
        } updated to ${status}`
      );
      setRaw('');
    } catch (err) {
      Snackbar.error('Failed to update products');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid
      container
      style={{ alignContent: 'flex-start', padding: '20px 5px 10px' }}
    >
      <Grid container justifyContent="center">
        <Typography
          style={{
            fontFamily: 'Montserrat',
            fontSize: 24,
            lineHeight: '28px',
            letterSpacing: '0.1em',
            marginBottom: 25,
          }}
        >
          BULK PRODUCT STATUS
        </Typography>
      </Grid>

      <Grid container style={{ padding: '0 24px' }}>
        <Grid container alignItems="flex-start">
          <Grid style={{ width: 620, marginRight: 24 }}>
            <TextInput
              field="Style Codes (one per line)"
              value={raw}
              onChange={e => setRaw(e.target.value)}
              multiline
              rows={14}
              minHeight={280}
              width={620}
              placeholder={'2705057\n2704021\n2705022\n...'}
            />
            <Typography
              style={{ fontSize: 12, color: '#5b5b5b', marginTop: 8 }}
            >
              {styleCodes.length === 0
                ? 'No codes detected yet'
                : `${styleCodes.length} unique style code${
                    styleCodes.length === 1 ? '' : 's'
                  } ready`}
            </Typography>
          </Grid>

          <Grid style={{ width: 260 }}>
            <TextInput
              select
              field="Status"
              options={STATUS_OPTIONS}
              value={status}
              onChange={e => setStatus(e.target.value)}
              height={40}
              width={260}
              background="#ebebeb"
            />

            <Grid container style={{ marginTop: 32 }}>
              <Button
                text="Apply Changes"
                color="#000"
                textColor="#fff"
                width={260}
                height={40}
                loading={saving}
                onClick={handleApply}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
